import { AGENCIES } from 'constants/constants';

export default function getCarrierLogoUrl(code) {
  return code && AGENCIES[code]?.logo?.external
    ? `${process.env.REACT_APP_PUBLIC_ASSETS}/carrier-logos/${AGENCIES[code].logo.external}`
    : '';
}
